<div class="hue-container">
  <div
    #container
    class="hue-gradient"
    [style.height.px]="gradientHeight"
    [style.width.px]="gradientWidth"
    tabindex="0"
    (mousedown)="setHue($event)"
  >
    <div
      #cursor
      class="cursor"
      [style.left.px]="huePos"
      [style.height.px]="gradientHeight + 3"
      (mousedown)="onCursorMouseDown($event)"
    ></div>
  </div>
</div>
